// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1J6cd","bigColWidth":"Table_bigColWidth__2ovQX","biggerColWidth":"Table_biggerColWidth__2_v9q","row":"Table_row__3F0Zg","col":"Table_col__3glgQ"};